import Cookie from "js-cookie";
import { wildCart, AddToCart } from "components/adafruit/wildcart";

export default class Cart {
  constructor() {
    this.setupProductLinks();

    this.cache_timeout = 2 * 60 * 1000; // 2 minutes (in milliseconds)
  }

  setupProductLinks() {
    this.setupIndividualProductButtons();
    this.initializeExistingCart();
  }

  setupIndividualProductButtons() {
    const productButtons = document.querySelectorAll(
      ".product-buy:not(.notify):not(.subscription)",
    );

    // Process each button individually
    productButtons.forEach((button) => {
      new AddToCart(button, {
        wildCart,
        onAdded: (data) => {
          // Handle successful add to cart
          button.innerHTML = "Added!";
          setTimeout(() => {
            button.innerHTML = "Add to Cart";
          }, 2000);
        },
      });
    });
  }

  initializeExistingCart() {
    if (Cookie.get("cart_count")) {
      this.updateCartCount();
      this.fetchCartData();
    }
  }

  updateProductButtonStatus(data) {
    if (data && data.cart) {
      Object.keys(data.cart).forEach((key) => {
        const element = document.getElementById(`${key}-product`);
        if (element) {
          element.innerHTML = "Added!";
        }
      });
    }
  }

  fetchCartData() {
    const CACHE_KEY = "cache-learn-cart";

    // Try to get cart data from cache first
    const cachedData = this.getCartFromCache(CACHE_KEY);
    if (cachedData) {
      this.updateProductButtonStatus(cachedData);
      return;
    }

    // If no cache or expired, fetch from server
    this.fetchCartFromServer(CACHE_KEY);
  }

  getCartFromCache(cacheKey) {
    if (!localStorage) return null;

    try {
      const cached = JSON.parse(localStorage.getItem(cacheKey));

      if (cached && cached.timestamp && Date.now() < cached.timestamp) {
        return cached.data;
      }
    } catch (error) {
      console.log("Error retrieving cart data from cache:", error);
    }

    return null;
  }

  fetchCartFromServer(cacheKey) {
    const token = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");

    const headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };

    if (token) {
      headers["X-CSRF-Token"] = token;
    }

    fetch(wildCart.getCartUrl, {
      method: "POST",
      headers: headers,
      credentials: "include",
      cache: "no-store",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Network response error: ${response.status} ${response.statusText}`,
          );
        }
        return response.json();
      })
      .then((data) => {
        // Cache the data
        this.cacheCartData(cacheKey, data);

        // Update UI
        this.updateProductButtonStatus(data);
        this.updateCartCount();
      })
      .catch((error) => {
        console.log(`Error fetching cart: ${error.message}`);
      });
  }

  cacheCartData(cacheKey, data) {
    if (!localStorage) return;

    try {
      const cacheEntry = {
        timestamp: Date.now() + this.cache_timeout,
        data: data,
      };

      localStorage.setItem(cacheKey, JSON.stringify(cacheEntry));
    } catch (error) {
      console.log("Error storing cart data in cache:", error);
    }
  }

  updateCartCount() {
    const cartCount = Cookie.get("cart_count");
    const text = `<i class='fa fa-shopping-cart'></i> ${cartCount}`;

    const cartLink = document.querySelector(".cart a");
    if (cartLink) {
      cartLink.innerHTML = text;
    }
  }
}
